export { default as ContentfulProductQuartet } from './contentfulProductQuartet'



// WEBPACK FOOTER //
// ./src/modules/contentful/productQuartet/index.js